import { roles as baseRoles, RoleModel as BaseRoleModel } from './baseApi/roles'
import type { OverrideResults } from './overrideResult'

export type * from './baseApi/roles'

export enum UserRoleEnum {
  owner = 'Eier',
  tenant = 'Leietaker',
  cohabitant = 'Beboer',
  member = 'Medlem',
  portal = 'StyreportalBruker',
  invoiceApprover = 'FakturaGodkjenner',
  invoiceAttester = 'FakturaAttesterer',
  boardleader = 'StyreLeder',
  boardmember = 'StyreMedlem',
  boardnextleader = 'StyreNestleder',
  alternateboardmember = 'StyreVaraMedlem',
  secretary = 'StyreSekretær',
  cashier = 'StyreKasserer',
  committee = 'StyreValgKomite',
  accountant = 'Revisor',
  powerofattorney = 'Fullmaktshaver',
  caretaker = 'Vaktmester',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  auditor = 'Revisor',
  digitalkeys = 'DigitaleNokler',
  advisor = 'Raadgiver',
  advisorFullAccess = 'RaadgiverMedFullTilgang',
  preemption = 'ForkjopsrettBruker',
  support = 'TekniskSupport',
  ceo = 'StyreTilknyttetDagligLeder',
}

export type RoleModel = Omit<BaseRoleModel, 'role'> & {
  role: UserRoleEnum
}

export const rolesApi = baseRoles.enhanceEndpoints<
  never,
  OverrideResults<typeof baseRoles, { getRole: RoleModel[] }>
>({
  endpoints: {},
})

export const { useGetRoleQuery } = rolesApi
